import { useIntl, defineMessages } from 'react-intl';
import cx from 'classnames';

const messages = defineMessages({
  openNavMenu: {
    id: 'Open menu',
    defaultMessage: 'Open menu',
  },
  closeNavMenu: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
});

const NavigationButton = ({ isNavMenuOpen, toggleNavMenu }) => {
  const intl = useIntl();
  return (
    <div className="hamburger-wrapper">
      <button
        className={cx('hamburger-toggler hamburger-toggler--collapse', {
          'is-active': isNavMenuOpen,
        })}
        aria-expanded={isNavMenuOpen}
        aria-label={
          isNavMenuOpen
            ? intl.formatMessage(messages.closeNavMenu)
            : intl.formatMessage(messages.openNavMenu)
        }
        title={
          isNavMenuOpen
            ? intl.formatMessage(messages.closeNavMenu)
            : intl.formatMessage(messages.openNavMenu)
        }
        type="button"
        onClick={toggleNavMenu}
      >
        <div
          className={cx('hamburger hamburger--collapse', {
            'is-active': isNavMenuOpen,
          })}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </div>
      </button>
    </div>
  );
};

export default NavigationButton;
